import React from "react";
import { Plus, UtensilsCrossed } from "lucide-react";
import { useTranslation } from "react-i18next";
import { formatGNF, imgUrl } from "@/utils/format";
import TTSButton from "@/components/TTSButton";
import { SpicyBadge } from "@/components/SpicyBadge";

export default function DishCard({ dish, onAdd }) {
  const { t } = useTranslation();
  const ttsText = [dish?.name, dish?.description].filter(Boolean).join(". ").trim();
  return (
    <div data-testid={`dish-card-${dish.dish_id}`} className="bg-white rounded-2xl p-4 flex gap-4 border border-sand hover:shadow-[0_8px_30px_rgba(0,0,0,0.06)] transition-shadow">
      <div className="flex-1 min-w-0">
        <h4 className="font-display text-base sm:text-lg font-semibold text-ink flex items-center gap-2">
          {dish.name} <SpicyBadge level={dish.spicy_level} testId={`dish-spicy-${dish.dish_id}`} />
        </h4>
        <p className="text-sm text-mute mt-1 line-clamp-2">{dish.description}</p>

        <div className="mt-2">
          <TTSButton
            text={ttsText}
            testId={`dish-tts-${dish.dish_id}`}
            ariaLabel={t("dish.listenDescription", { name: dish.name })}
          />
        </div>

        <div className="mt-3 flex items-center justify-between">
          <span className="font-display text-lg font-semibold text-ink">{formatGNF(dish.price)}</span>
          <button
            onClick={() => onAdd?.(dish)}
            data-testid={`dish-add-${dish.dish_id}`}
            className="rounded-full bg-brand-red hover:bg-[#C81F2D] text-white p-2 shadow-md hover:-translate-y-0.5 transition-all"
            aria-label={t("dish.add", { name: dish.name })}
          >
            <Plus className="w-4 h-4" />
          </button>
        </div>
      </div>
      <div className="w-24 h-24 sm:w-28 sm:h-28 rounded-xl overflow-hidden bg-elevated shrink-0">
        {dish.image ? (
          <img src={imgUrl(dish.image)} alt={dish.name} className="w-full h-full object-cover" loading="lazy" />
        ) : (
          <div className="w-full h-full grid place-items-center text-mute" aria-hidden="true">
            <UtensilsCrossed className="w-8 h-8 opacity-40" />
          </div>
        )}
      </div>
    </div>
  );
}
